var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFasion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.25V6.75C9.5 8.15625 10.5938 9.25 12 9.25C13.375 9.25 14.5 8.15625 14.5 6.75V5.25C14.5 4.71875 14.9375 4.25 15.5 4.25C16.0312 4.25 16.5 4.71875 16.5 5.25V6.25C16.5 9.09375 17.0938 10.75 17.5312 11.5938C17.7812 12.0312 18 12.5625 18 13.0938V18.25C18 19.375 17.0938 20.25 16 20.25H8C6.875 20.25 6 19.375 6 18.25V13.0938C6 12.5625 6.1875 12.0625 6.4375 11.5938C6.875 10.75 7.5 9.09375 7.5 6.25V5.25C7.5 4.71875 7.9375 4.25 8.5 4.25C9.03125 4.25 9.5 4.71875 9.5 5.25Z",
    fill: "#6D5FF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFasion);
export default __webpack_public_path__ + "static/media/_fasion.0e44e613b8668e63fd348c394ca78426.svg";
export { ForwardRef as ReactComponent };